export default "__VITE_ASSET__DwadulTt__"